import { useCallback } from "react";
import { startDocumentSectionsRefresh, type BatchJob } from "../../../../../lib/corpusApi";
import type { BatchJobParamsForm } from "../../batch_job_kind_contract";

export type UseDocumentSectionsRefreshParamsResult = BatchJobParamsForm;

/** A document_sections_refresh job asks for nothing: it covers the documents missing a section file when it
 *  starts, so it can always be started. */
export function useDocumentSectionsRefreshParams(): UseDocumentSectionsRefreshParamsResult {
  const start = useCallback(
    (name?: string): Promise<BatchJob> => startDocumentSectionsRefresh({ name }),
    []
  );

  return { canStart: true, start };
}
